<template>
  <div style="display: flex;">
    <div>
      <v-btn
      class="my-2"
      color="red"
      depressed
      block
      small
      outlined
      @click="deleteCache"
    >
      <span class="font-weight-bold">この記事のキャッシュを削除する</span>
    </v-btn>
    </div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <a href="https://support.b-cms.jp/60" target="_blank" class="mt-2 ml-3" v-bind="attrs" v-on="on">
          <v-icon color="grey lighten-1"> mdi-help-circle-outline </v-icon>
        </a>
      </template>
      <span style='font-size: 12px;'>キャッシュ削除とは</span>
    </v-tooltip>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  methods: {
    deleteCache () {
      if (!confirm('キャッシュを削除しますか？')) return true

      axios.delete(`/api/posts/${this.post.id}/cache_deletions`).then(
        () => {
          const payload = {
            status: 200,
            message: 'キャッシュを削除しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors
              ? error.response.data.errors.toString()
              : '空白です'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
